<script lang="ts">
import WMSCapabilities from 'ol/format/WMSCapabilities'
import { formatUrlToRequest } from '../../../utils/map/MapServiceHelper'
import { normalizeCrs, tileLoadAuthentification } from '../../../utils/map/OlLayerHelper'

export default {
    name: 'WMSLayer',
    props: {
        layer: { type: Object, required: true },
    },
    data() {
        return {
            serviceCapabilities: null,
        }
    },
    mounted() {
        this.getUrlService().then((res) => {
            this.serviceCapabilities = res
        })
    },
    methods: {
        getUrlService() {
            return new Promise<any>((resolve, reject) => {
                if (this.layer.url) {
                    const urlFormatted = formatUrlToRequest(this.layer.url, this.layer.type)

                    const headers = {
                        ...(this.layer.service.auth_login && this.layer.service.auth_password && {
                            Authorization: `Basic ${btoa(`${this.layer.service.auth_login}:${this.layer.service.auth_password}`)}`
                        })
                    };
                    $fetch(urlFormatted, { headers })
                        .then((res) => {
                            if (res) {
                                const parser = new WMSCapabilities()
                                const result = parser?.read(res)
                                resolve(result)
                            }
                        })
                        .catch(reject)
                }
            })
        },
        getStyle() {
            if (!this.layer.style && this.serviceCapabilities) {
                const layerMatch = this.serviceCapabilities.Capability.Layer.Layer?.find(l => l.Name === this.layer.name)
                if (layerMatch?.Style)
                    return layerMatch.Style[0]?.Name
            }
            return this.layer.style
        },
        normalizeCrs,
        getProjection(): string {
            if (this.layer.projection) return this.layer.projection
            if (!this.serviceCapabilities) return 'EPSG:3857'
            // CRS supported by this layer (child layer inherits from root layer)
            const layerMatch = this.serviceCapabilities.Capability.Layer.Layer?.find((l: any) => l.Name === this.layer.name)
            const crsList: string[] = (layerMatch?.CRS ?? this.serviceCapabilities.Capability.Layer?.CRS ?? []).map(normalizeCrs)
            const preferred = ['EPSG:3857', 'EPSG:4326']
            return preferred.find(crs => crsList.includes(crs)) ?? crsList[0] ?? 'EPSG:3857'
        },
        getTileAuthentification(tile: any, src: string) {
            tileLoadAuthentification(tile, src, this.layer, 'WMS')
        },
    },
}
</script>

<template>
<!--            min-resolution="MinScaleDenominator"
        max-resolution="MaxScaleDenominator"-->
    <ol-tile-layer
        :title="layer.title" :visible="layer.show" :class-name="layer.name" :properties="{ ...layer }"
        :z-index="layer.zIndex"
    >
        <template v-if="serviceCapabilities?.Capability">
            <ol-source-tile-wms
                :url="layer.service.url"
                :layers="layer.name"
                :styles="getStyle()"
                :attributions="layer.attribution"
                :tileLoadFunction="getTileAuthentification"
                crossOrigin="anonymous"
                :projection="getProjection()"
            />
        </template>

    </ol-tile-layer>
</template>

<style scoped>

</style>
